import React, { Fragment } from 'react'
import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Hidden } from '@material-ui/core'
import Button from 'components/theme/Button'
import language from 'utils/vast-languagepack'
import BackButton from 'components/TemplateForm/BackButton'
import { last } from 'lodash'

const CancelButton = withRouter(({ history }) => {
  const button = (size) => (
    <Button
      size={size}
      variant="outlined"
      color="secondary"
      onClick={() => {
        history.goBack()
      }}
    >
      {language.task.add.cancelButton}
    </Button>
  )

  return (
    <Fragment>
      <Hidden smDown>{button('medium')}</Hidden>
      <Hidden mdUp>{button('small')}</Hidden>
    </Fragment>
  )
})

export default connect(
  (state) => ({ backButtonDisplayed: last(state.email.cardSelected) !== null }),
  null,
)(({ backButtonDisplayed }) =>
  backButtonDisplayed ? <BackButton text="Theme" /> : <CancelButton />,
)
